import React from "react";

const ShowcaseLayout: React.FC<{ settings: React.ReactNode; preview: React.ReactNode }> = ({ settings, preview }) => (
  <div className="grid gap-6 lg:grid-cols-[minmax(0,1fr)_minmax(0,2fr)] lg:grid-rows-[minmax(0,1fr)] lg:flex-1 lg:min-h-0 lg:min-w-0">
    <div className="@container p-1 flex flex-col min-w-0 lg:min-h-0">{settings}</div>
    <div className="p-1 flex flex-col min-w-0 lg:min-h-0">{preview}</div>
  </div>
);

export { ShowcaseLayout };
